import { Component, Input, OnInit } from '@angular/core';
import { MODAL, ModalService } from 'src/app/modals/modal.service';
import { Context } from 'src/app/utils/context';
import { OrderHistoryService as ColleagueOrderHistoryService } from '@proxy/user-casto/order-history';
import { OrderHistoryService } from 'src/publicproxy/src/proxy/public/order-history';
import { PagedResultDto } from '@abp/ng.core';
import { ActivityPurchaseChDto } from '@proxy/cheetah/client/dto';
import { GTM } from 'src/app/_services/gtm.service';

@Component({
  selector: 'ng-casto-common-customer-order-history',
  templateUrl: './customer-order-history.component.html',
})
export class CustomerOrderHistoryComponent implements OnInit {
  orderHistories: PagedResultDto<ActivityPurchaseChDto> = { items: [], totalCount: 0 };
  @Input() customerId = '';
  @Input() resume = false;
  @Input() context: Context = Context.Colleague;

  loading = false;
  first = 0;
  rows = 5;
  totalRecords = 0;

  ean: string = '';
  periodStart?: string;
  periodEnd?: string;

  constructor(
    private readonly orderHistoryService: OrderHistoryService,
    private readonly colleagueOrderHistoryService: ColleagueOrderHistoryService,
    private readonly modalService: ModalService,
    private readonly gtm: GTM
  ) { }

  ngOnInit(): void {
    this.loadPageData(1, this.rows);
  }

  get displaySearchFilters() {
    return this.context === Context.Colleague && !this.resume;
  }

  private loadPageData(pageNumber: number, resultPerPage: number): void {
    this.loading = true;

    const query: any = {
      customerId: this.customerId,
      pageNumber,
      resultPerPage,
    };

    if (this.ean) {
      query.ean = this.ean;
    }

    if (this.periodStart && this.periodEnd) {
      query.periodStart = this.periodStart;
      query.periodEnd = this.periodEnd;
    }

    const source$ =
      this.context === Context.Colleague
        ? this.colleagueOrderHistoryService.getOrderHistory(query)
        : this.orderHistoryService.getOrderHistory(query);

    source$.subscribe({
      next: (response: PagedResultDto<ActivityPurchaseChDto>) => {
        this.orderHistories = response;
        this.totalRecords = response.totalCount;
        this.loading = false;
      },
      error: () => {
        this.orderHistories = { items: [], totalCount: 0 };
        this.totalRecords = 0;
        this.loading = false;
      },
    });
  }

  onPageChange(event: any): void {
    this.first = event.first;
    this.rows = event.rows;

    const pageNumber = event.page + 1;
    const resultPerPage = event.rows;

    this.loadPageData(pageNumber, resultPerPage);
  }

  openDetails(order: ActivityPurchaseChDto): void {
    this.gtm.trackInteraction('clic_historique', order.ticketNumberAssociated, { store_id: order.storeIdAssociated });
    this.modalService.display(MODAL.ORDER_DETAILS, {
      customerId: this.customerId,
      orderId: order.orderIdAssociated,
      context: this.context,
    });
  }

  search() {
    this.first = 0;
    this.loadPageData(1, this.rows);
  }

  clearFilters() {
    this.ean = '';
    this.periodStart = undefined;
    this.periodEnd = undefined;
    this.first = 0;
    this.loadPageData(1, this.rows);
  }
}
